// extracted by mini-css-extract-plugin
export default {"menu-container":"CaptureModal_menu-container__OEOK4"};